import { render } from "./FixedPlugin.vue?vue&type=template&id=7d4fa498"
import script from "./FixedPlugin.vue?vue&type=script&lang=js"
export * from "./FixedPlugin.vue?vue&type=script&lang=js"

import "./FixedPlugin.vue?vue&type=style&index=0&id=7d4fa498&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__